import { render, staticRenderFns } from "./ListOfObjects.vue?vue&type=template&id=666c408a&"
import script from "./ListOfObjects.vue?vue&type=script&lang=js&"
export * from "./ListOfObjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports